// extracted by mini-css-extract-plugin
export default {"mainDiv":"admins_mainDiv__lNcWv"};